<h1 class="page-title mb-5">مواقع مقترحة</h1>
<div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-9">
        <div class="faq-container py-5">
          <div class="faq-item" *ngFor="let item of items">
            <div class="faq-header" (click)="toggle(item)">
              <div class="indicator" [class.expanded]="item.expanded">
                <i class="fa-solid" [class.fa-minus]="item.expanded" [class.fa-plus]="!item.expanded"></i>
              </div>
              <div class="title">{{ item.title }}</div>
            </div>
            <div class="faq-content" *ngIf="item.expanded">
              <ul class="suggested-sites-list">
                <li *ngFor="let site of item.content">
                  <a [href]="site.url" target="_blank" rel="noopener noreferrer">
                    <i class="fa-solid fa-circle-arrow-left"></i>
                    {{ site.name }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <app-fixed-go-on></app-fixed-go-on>
      </div>
    </div>
  </div>
</div>